import { render, staticRenderFns } from "./LayersPanel.vue?vue&type=template&id=bc5298f0&scoped=true"
import script from "./LayersPanel.vue?vue&type=script&lang=js"
export * from "./LayersPanel.vue?vue&type=script&lang=js"
import style0 from "./LayersPanel.vue?vue&type=style&index=0&id=bc5298f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5298f0",
  null
  
)

export default component.exports